export default __webpack_public_path__ + "static/media/undraw_taken_re_yn20.0dd3c4cc.svg";